import { Component, OnInit, Input, forwardRef, ViewChild, ChangeDetectorRef, AfterViewChecked, Output } from '@angular/core';
import { trigger, style, animate, transition } from '@angular/animations';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FormGroup, FormBuilder, Validators, AbstractControl, ValidatorFn } from '@angular/forms';
import { ExpressBookingService } from '../../services/express-booking-widget';
import { ActionUpdaterService, ApiError } from '../../services/action-updater.service';
import { LocalStorageService } from 'app/shared/services/local-storage.service';
import { Passengers } from 'app/shared/models/passenger.model';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap';
import { modalClass } from 'app/home/booking-widget-container/booking-widget-container.component';
import { InitialDataService, PassengerFareType } from '../../../initial-data.service';
import { ModalPopupMainPageEvent } from '../../models/app-events-types.model';
import { ModalPopupMainPageEventWrapper } from '../../models/app-events.model';
import { EventBusService } from '../../services/event-bus.service';

@Component({
    selector: 'gaweb-home-passenger-options',
    templateUrl: './home-passenger-options.component.html',
    animations: [
        trigger(
            'expandOutWithInputFields', [
                transition(':enter', [
                    style({ height: 0, opacity: 0 }),
                    animate('200ms ease-out', style({ height: '!', opacity: 1 })) // No constiable height until Angular 4.2 :(
                ]),
                transition(':leave', [
                    style({ height: '!', opacity: 1 }),
                    animate('200ms ease-out', style({ height: 0, opacity: 0 }))
                ])
            ]
        ),
        trigger(
            'expandOutSeatedInfant', [
                transition(':enter', [
                    style({ opacity: 0 }),
                    animate('200ms 201ms ease-out', style({ opacity: 1 }))
                ]),
                transition(':leave', [
                    style({ opacity: 0 }),
                    animate('200ms ease-out', style({ opacity: 0 }))
                ])
            ]
        ),
        trigger(
            'expandOutNursedInfant', [
                transition(':enter', [
                    style({ height: '0px', opacity: 0 }),
                    animate('200ms 201ms ease-out', style({ height: '!', opacity: 1 }))
                ]),
                transition(':leave', [
                    style({ height: '!', opacity: 0 }),
                    animate('200ms ease-out', style({ height: '0px', opacity: 0 }))
                ])
            ]
        ),
        trigger(
            'expandOutInfant', [
                transition(':enter', [
                    style({ opacity: 0 }),
                    animate('200ms 201ms ease-out', style({ opacity: 1 }))
                ]),
                transition(':leave', [
                    style({ opacity: 1 }),
                    animate('200ms ease-out', style({ opacity: 0 }))
                ])
            ]
        )
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => HomePassengerOptionsComponent),
            multi: true
        }
    ]
})
export class HomePassengerOptionsComponent implements OnInit, ControlValueAccessor, AfterViewChecked {
    @ViewChild('childModal') public childModal: ModalDirective;
    private _value: Passengers;
    get value() {
        return this._value;
    }
    @Input()
    set value(val: Passengers) {
        if (val) {
            this._value = val;
            this.buildForm(val);
            this.onChange(val);
            this.onTouched();
        }
    }

    public config = {
        animated: true,
        keyboard: true,
        backdrop: false,
        ignoreBackdropClick: false
    };
    passengersPretty: string;

    max = 7;
    maxConcessions = 2;
    maxInfants = 4;
    min = 0;
    passengerOptionsForm: FormGroup;
    showConcessionCard = false;
    concessionLater = false;
    showStudentCard = false;
    studentLater = false;
    passengerSummary: string;
    passengersValid = false;
    processing: boolean;
    infantOptionsDisplaying = false;
    display = {
        adult: '',
        concession: '',
        student: '',
        accompaniedChild: '',
        unaccompaniedChild: '',
        infant: ''
    };
    set concessionCard1(v: string) {
        this.passengerOptionsForm.controls['concessionCard1'].patchValue(v);
    }
    set concessionCard2(v: string) {
        this.passengerOptionsForm.controls['concessionCard2'].patchValue(v);
    }
    set studentCard1(v: string) {
        this.passengerOptionsForm.controls['studentCard1'].patchValue(v);
    }
    set studentCard2(v: string) {
        this.passengerOptionsForm.controls['studentCard2'].patchValue(v);
    }
    onChange: any = () => { };
    onTouched: any = () => { };
    constructor(
        private fb: FormBuilder,
        private expressBookingService: ExpressBookingService,
        private actionUpdaterService: ActionUpdaterService,
        private localStorageService: LocalStorageService,
        private initialDataService: InitialDataService,
        private eventBusService: EventBusService,
        private cdRef: ChangeDetectorRef) { }

    ngOnInit() {
        const passengerFareTypes: PassengerFareType[] = this.initialDataService.fareTypes;
        passengerFareTypes.forEach((v: PassengerFareType) => {
            const text = v.Display;
            switch (v.Code) {
                case '000':
                    this.display.adult = text;
                    break;
                case '041':
                    this.display.concession = text;
                    break;
                case '220':
                    this.display.student = text;
                    break;
                case '418':
                    this.display.accompaniedChild = text;
                    break;
                case '420':
                    this.display.unaccompaniedChild = text;
                    break;
                case '451':
                    this.display.infant = text;
                    break;
            }
        });
        this.resetForm();
    }
    ngAfterViewChecked() {
        this.cdRef.detectChanges();
    }
    private buildForm(travelPassengers: Passengers) {
        if (!!this.passengerOptionsForm) {
            if (!!travelPassengers) {
                this.passengerOptionsForm.patchValue(this.getObjectToFillForm(travelPassengers));
            } else {
                this.passengerOptionsForm.patchValue(this.getObjectToClearForm());
            }
        } else {
            if (!!travelPassengers) {
                this.passengerOptionsForm = this.fb.group(this.getObjectToFillForm(travelPassengers));
            } else {
                this.passengerOptionsForm = this.fb.group(this.getObjectToClearForm());
            }
        }

    }
    private getObjectToClearForm() {
        return {
            adults: 0,
            concessions: 0,
            children: 0,
            seatedInfant: 0,
            nursedInfant: 0,
            accompaniedChildren: 0,
            infants: 0,
            concessionCard1: null,
            concessionCard2: null,
            concessionLater: false,
            studentCard1: null,
            studentCard2: null,
            studentLater: false,
            students: 0
        };
    }
    private getObjectToFillForm(travelPassengers: Passengers) {
        return {
            adults: travelPassengers.adults || 0,
            concessions: travelPassengers.concessions || 0,
            seatedInfant: travelPassengers.seatedInfant,
            nursedInfant: travelPassengers.nursedInfant,
            accompaniedChildren: travelPassengers.accompaniedChildren,
            infants: travelPassengers.infants || 0,
            concessionCard1: travelPassengers.concessionCard1,
            concessionCard2: travelPassengers.concessionCard2,
            concessionLater: travelPassengers.concessionLater,
            studentCard1: travelPassengers.studentCard1,
            studentCard2: travelPassengers.studentCard2,
            studentLater: travelPassengers.studentLater,
            students: travelPassengers.students || 0
        };
    }
    private resetForm() {
        this.buildForm(this.value);
        this.value = this.expressBookingService.getPassengerObject(this.passengerOptionsForm);
        if (this.localStorageService.getTravelPassengers() != null) {
            this.value = this.localStorageService.getTravelPassengers();
            this.buildForm(this.value);
        }
        this.passengerSummary = this.expressBookingService.getPassengerSummary(this.passengerOptionsForm);
        this.passengerOptionsForm.controls['concessions'].valueChanges.subscribe(val => {
            this.onConcessionUpdated(val);
        });
        this.passengerOptionsForm.controls['students'].valueChanges.subscribe(val => {
            this.onStudentUpdated(val);
        });
        this.onConcessionLaterClicked(null);
        this.onStudentLaterClicked(null);
    }

    onConcessionUpdated(count: number) {
        if (count > 0) {
            this.showConcessionCard = true;
            if (count === 1) {
                this.concessionCard2 = '';
            }
        } else {
            this.showConcessionCard = false;
            this.concessionCard1 = '';
            this.concessionCard2 = '';
        }
    }
    onStudentUpdated(count: number) {
        if (count > 0) {
            this.showStudentCard = true;
            if (count === 1) {
                this.studentCard2 = '';
            }
        } else {
            this.showStudentCard = false;
            this.studentCard1 = '';
            this.studentCard2 = '';
        }
    }

    openPassengersSelectionPicker() {
        this.showModal();
        this.isPassengersCombinationValid();
    }
    finishEnteringPassengerOptions() {
        this.processing = true;
        this.actionUpdaterService.announceClear(true);
        this.passengerSummary = this.expressBookingService.getPassengerSummary(this.passengerOptionsForm);
        this.value = this.expressBookingService.getPassengerObject(this.passengerOptionsForm);
        this.hideModal();
        this.processing = false;
    }

    passengerOptionsFormInvalid() {
        return false;
    }

    registerOnChange(fn) {
        this.onChange = fn;
    }

    registerOnTouched(fn) {
        this.onTouched = fn;
    }

    writeValue(value) {
        if (value) {
            this.value = value;
        }
    }

    onConcessionLaterClicked($event) {
        if (this.passengerOptionsForm.get('concessionLater').value) {
            this.passengerOptionsForm.get('concessionCard1').disable();
            this.passengerOptionsForm.get('concessionCard2').disable();
            this.concessionCard1 = '';
            this.concessionCard2 = '';
        } else {
            this.passengerOptionsForm.get('concessionCard1').enable();
            this.passengerOptionsForm.get('concessionCard2').enable();
        }
        this.isPassengersCombinationValid();
    }
    onStudentLaterClicked($event) {
        if (this.passengerOptionsForm.get('studentLater').value) {
            this.passengerOptionsForm.get('studentCard1').disable();
            this.passengerOptionsForm.get('studentCard2').disable();
            this.studentCard1 = '';
            this.studentCard2 = '';
        } else {
            this.passengerOptionsForm.get('studentCard1').enable();
            this.passengerOptionsForm.get('studentCard2').enable();
        }
        this.isPassengersCombinationValid();
    }

    showInfantBreakdown() {
        const totalAdults = this.getTotalAdults();
        const totalSeats = this.getTotalSeats();
        const infants = this.passengerOptionsForm.controls['infants'].value;
        const seatedInfant = this.passengerOptionsForm.get('seatedInfant').value;
        const nursedInfant = this.passengerOptionsForm.get('nursedInfant').value; 

        const result = (totalSeats >= 2 && infants > 0) || (totalSeats >= 2 && (seatedInfant + nursedInfant) > 0 ) || this.infantOptionsDisplaying === true;

        if(result === true) {
            this.infantOptionsDisplaying = true;
        }
        return result
    }

    onAdultChange() {
        const numAdults = this.getTotalAdults();
        const totalSeats = this.getTotalSeats();
        const infants = this.passengerOptionsForm.get('infants').value;
        const seatedInfants = this.passengerOptionsForm.get('seatedInfant').value;
        const nursedInfants = this.passengerOptionsForm.get('nursedInfant').value;

        if (totalSeats < 2) {
            if (seatedInfants + nursedInfants > 0) {
                this.passengerOptionsForm.controls['infants'].setValue(seatedInfants + nursedInfants);
            }

            this.passengerOptionsForm.controls['seatedInfant'].setValue(0);
            this.passengerOptionsForm.controls['nursedInfant'].setValue(0);
        }

        if (this.showInfantBreakdown() && seatedInfants === 0) {
            if (infants !== 0) {
                this.passengerOptionsForm.controls['seatedInfant'].setValue(infants);
                this.passengerOptionsForm.controls['infants'].setValue(0);
            }
        }

        this.isPassengersCombinationValid();
    }

    isPassengersCombinationValid() {
        const passengers = this.getPassengers();
        this.passengersValid = this.expressBookingService.isPassengersCombinationValid(passengers, this.passengerOptionsForm);
        return this.passengersValid;
    }

    getTotalAdults() {
        const adults = this.passengerOptionsForm.controls['adults'].value,
            concessions = this.passengerOptionsForm.controls['concessions'].value,
            students = this.passengerOptionsForm.controls['students'].value;
        return adults + concessions + students;
    }

    
    getTotalSeats() {
        const adults = this.passengerOptionsForm.controls['adults'].value,
            concessions = this.passengerOptionsForm.controls['concessions'].value,
            students = this.passengerOptionsForm.controls['students'].value,
            children = this.passengerOptionsForm.controls['accompaniedChildren'].value;
        return adults + concessions + students + children;
    }

    getTotalInfants() {
        return this.passengerOptionsForm.get('infants').value;
    }
    showModal() {
        this.childModal.show();
        $('#passengerOptionsModal').appendTo('gaweb-booking-widget-container');
        const ev = new ModalPopupMainPageEvent(true);
        this.eventBusService.emit(new ModalPopupMainPageEventWrapper(ev));
    }
    hideModal() {
        $('#passengerOptionsModal').appendTo('#passengerOptionsForm');
        this.childModal.hide();
        if (!this.processing) {
            this.resetForm();
        }
        const ev = new ModalPopupMainPageEvent(false);
        this.eventBusService.emit(new ModalPopupMainPageEventWrapper(ev));
    }
    public getPassengers(): Passengers {
        const numAdults = this.getTotalAdults();
        if (numAdults < 2) {
            const passengers: Passengers = this.passengerOptionsForm.getRawValue();
            if (passengers.infants === 1) {
                passengers.seatedInfant = 1;
                passengers.infants = 0;
            } else if (passengers.infants === 2) {
                passengers.seatedInfant = 1;
                passengers.nursedInfant = 1;
                passengers.infants = 0;
            }
            return passengers;
        } else {
            return this.passengerOptionsForm.getRawValue() as Passengers;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/home-passenger-options/home-passenger-options.component.ts